import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';

const stats = [
  { value: '1 min', label: 'Data readings' },
  { value: '5yr', label: 'Data retention' },
  { value: 'Hourly', label: 'Automated rules engine' },
  { value: '24/7', label: 'Real-time alerts' },
];

const DashboardSection = () => {
  return (
    <>
      {/* Stats band - dark with dividers */}
      <Box sx={{ backgroundColor: '#050505', py: { xs: 8, md: 10 }, borderTop: '1px solid #111', borderBottom: '1px solid #111' }}>
        <Container maxWidth="lg">
          <Grid container>
            {stats.map((stat, i) => (
              <Grid key={i} size={{ xs: 6, md: 3 }}>
                <Box
                  sx={{
                    textAlign: 'center',
                    py: { xs: 3, md: 0 },
                    px: 2,
                    borderRight: i < stats.length - 1 ? '1px solid #1e1e1e' : 'none',
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Outfit',
                      fontWeight: 800,
                      fontSize: { xs: '2.6rem', md: '3.4rem' },
                      color: '#ffffff',
                      lineHeight: 1,
                      mb: 0.75,
                      letterSpacing: '-0.03em',
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Outfit',
                      fontWeight: 400,
                      fontSize: '0.8rem',
                      color: 'rgba(255,255,255,0.4)',
                      letterSpacing: '0.12em',
                      textTransform: 'uppercase',
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Dashboard content section */}
      <Box sx={{ backgroundColor: '#ffffff', py: { xs: 10, md: 16 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 6, md: 10 }} alignItems="center">
            {/* Dashboard visual */}
            <Grid size={{ xs: 12, md: 6 }} sx={{ order: { xs: 2, md: 1 } }}>
              <Box
                component="img"
                src="/dashboard.png"
                alt="Sigmatiqa Dashboard"
                sx={{
                  width: '100%',
                  display: 'block',
                  borderRadius: '14px',
                  border: '1px solid #e8e8e8',
                  boxShadow: '0 24px 80px rgba(0,0,0,0.10)',
                }}
              />
            </Grid>

            {/* Text */}
            <Grid size={{ xs: 12, md: 6 }} sx={{ order: { xs: 1, md: 2 } }}>
              <Typography
                component="span"
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 500,
                  fontSize: '0.78rem',
                  color: '#004D40',
                  letterSpacing: '0.15em',
                  textTransform: 'uppercase',
                  display: 'block',
                  mb: 1.5,
                }}
              >
                Sigmatiqa Dashboard
              </Typography>
              <Typography
                component="h2"
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 800,
                  fontSize: { xs: '2rem', md: '2.9rem' },
                  color: '#000000',
                  lineHeight: 1.08,
                  letterSpacing: '-0.03em',
                  mb: 3,
                }}
              >
                Unlock valuable insights with the Sigmatiqa dashboard
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 400,
                  fontSize: '1rem',
                  color: '#666666',
                  lineHeight: 1.85,
                  mb: 2,
                }}
              >
                Our intuitive dashboard empowers you with the insights that matter most to your
                business. Monitor temperatures, receive real-time compliance alerts, and check
                battery health - all from a single, easy-to-navigate screen.
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 400,
                  fontSize: '1rem',
                  color: '#666666',
                  lineHeight: 1.85,
                  mb: 5,
                }}
              >
                Every data point is stored securely for up to 5 years, giving you peace of mind
                and access whenever you need it.
              </Typography>
              <Button
                href="https://app.sigmatiqa.com"
                disableElevation
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  textTransform: 'none',
                  backgroundColor: '#004D40',
                  color: '#ffffff',
                  px: 4,
                  py: 1.5,
                  borderRadius: '7px',
                  '&:hover': { backgroundColor: '#00695C' },
                  transition: 'background-color 0.2s',
                }}
              >
                Access Dashboard
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default DashboardSection;